import { defineStore } from 'pinia';
import { deepCopy, getFirstItem } from '../tool/format.ts';
import { isArray, deduplicateArray } from '@/tool/helpme.ts';
import { formatDateTime } from '@/tool/format';

export const useReportStore = defineStore('report', {
  state: () => {
    return {
      // 存储其它页面跳转携程的参数
      navigationParams: {},
      // 当前选中的 监测批次 、 监测系统 、 上报类型 数据，全局存储
      selectedContext: {},
      // 原始数据
      originalReportData: {},
      // 初始化字段
      formTemplates: {
        // 损耗
        lossRequest: {
          lossReason: '',
          // 附件 图片
          uploadFiles: [],
          // 鱼池编号
          details: [],
          submitDate: '',
        },

        // 投喂
        feedingRequest: {
          totalWeight: '', //投喂总重量
          feedingCondition: '', //吃料情况
          uploadFiles: [],
          submitDate: '',
        },
        // 用药
        medicationRequest: {
          medicine: '', //用药名称
          dosage: '', //剂量 (所有总和)
          unit: '', //单位
          purpose: '', //用途
          // 附件 图片
          type: '用药',
          uploadFiles: [],
          method: '搅拌',
          submitDate: '',
        },
        // 用药2。动保
        aquaMedication: {
          type: '用药',
          medicationDetails: [], // 用药详情
          uploadFiles: [], //附件
          remark: '', //备注
          fileId: '',
          id: '',
          submitDate: '', //记录时间
        },
        // 水质
        waterRequest: {
          uploadFiles: [],
          location: '',
          remark: '',
          waterResult: '正常',
          type: '1',
          submitDate: new Date(),
        },

        // --- 每一种【检验】是一个表单 ------------------------
        // 生长 检测

        growthSituationRequest: {
          sampling: '', //取样数量
          samplingWeight: '', //取样重量
          averageWeight: '', //平均重量
          averageLength: '', //平均长度
          averageSpec: '', //平均规格
          examiningResult: '', //检测结果
          remark: '', //备注
          uploadFiles: [],
          submitDate: '',
        },
        // 健康
        healthRecordRequest: {
          posture: '', //体态
          bodyColour: '', //体色
          digestion: '', //消化情况
          feeding: '', //吃料情况
          stoolColor: '', //粪便颜色
          stoolState: '', //粪便状态
          vitality: '', //活力
          examiningResult: '', //检测结果
          remark: '', //备注
          uploadFiles: [],
          submitDate: '',
        },
        // 检验检测
        inspectionReportRequest: {
          stage: '', //阶段
          content: '', //检疫内容
          remark: '', //备注
          examiningResult: '', //检测结果
          uploadFiles: [],
          submitDate: '',
        },
        // --- 每一种【检验】是一个表单 ------------------------

        // 环境控制 environmentRecord
        environmentRecordRequest: {
          waterMark: '', //水位
          waterYield: '', //水量
          airHumidity: '', //空气湿度
          airTemperature: '', //空气温度
          barometricPressure: '', //气压
          remark: '', //备注
          uploadFiles: [], //附件
          environmentDate: '',
        },

        // 暂养
        // temporaryCareRecordRequest: {
        //   targetBaseId: '', //运往基地
        //   targetBase: '', //运往基地
        //   sourceBatchId: '', //来源批次
        //   sourceBatch: '', //来源批次
        //   variety: '', //品种
        //   spec: '', //品种规格
        //   specUnit: '尾/斤', //规格单位
        //   beforeQuantity: '', //运输前数量
        //   beforeUnit: '尾', //运输前单位
        //   afterQuantity: '', //运输后数量
        //   afterUnit: '尾', //运输后单位
        //   rearingMethod: '低温暂养', //暂养方式
        //   t: '', //气温
        //   humidity: '', //湿度
        //   o2: '', //溶氧
        //   startTime: new Date(), //开始时间
        //   endTime: new Date(), //结束时间
        //   uploadFiles: [],
        //   remark: '', //备注
        // },

        // 镜检
        microscopicRequest: {
          microObject: '', //检验对象
          microCase: '', //病原情况
          examiningResult: '无异常', //检验结果
          remark: '', // 备注
          uploadFiles: [], // 附件
          type: 'microscopic',
          submitDate: '',
        },
      },
      // 初始化字段/因为存在很多系统，系统id为 key,值为每一个对象
      reportDataSet: {
        // 批次 id
        // 系统id
      },
      // 鱼池数据
      pondDataSet: {},
      // 暂存的数据
      temporarilyData: {},

      // 提交成功的数据，主要ai做分析
      submitSuccessData: {},
      // 提交后展示提交的数据在首页ai给用户展示
      analysisShowView: {},
    };
  },
  actions: {
    // 用来匹配ai数据展示

    // 保持提交的数据做分析
    saveSubmitSuccessData(data) {
      this.submitSuccessData = data;
    },

    // 清空指定批次 系统的数据
    resetData(batchId, systemId) {
      if (batchId && systemId) {
        this.reportDataSet[batchId][systemId] = this.formTemplates;
      } else {
        // 清空所有系统数据
        this.reportDataSet = {};
        this.selectedContext = {};
      }
    },

    // 数据暂存
    setDataTemporaryStorage(data) {
      this.temporarilyData = data;
    },

    // 设置指定系统 指定批次 下的 附件
    optionsFiles(flag, data, formType) {
      let batchId = this.selectedContext.batchId;
      let systemId = this.selectedContext.systemId;

      console.log('batchId', batchId);
      console.log('systemId', systemId);
      console.log('data', data);
      console.log('formType', formType);

      this.reportDataSet[batchId][systemId][formType]['uploadFiles'].push(
        ...data
      );

      // //formType waterRequest
      // if (flag == 'set') {
      //   this.reportDataSet[batchId][systemId][formType]['uploadFiles'].push(
      //     ...data
      //   );
      // }
      // if (flag == 'get') {
      //   return this.reportDataSet[batchId]?.[systemId]?.[formType][
      //     'uploadFiles'
      //   ];
      // }
    },

    // 初始化字段
    setInitReportFeilds(data, callback) {
      if (data) {
        let _data = Array.isArray(data) ? data : [data];
        _data.forEach((rowItem, index) => {
          if (rowItem?.batchId) {
            // 判断是否以及存在批次
            if (!this?.reportDataSet.hasOwnProperty(rowItem.batchId)) {
              this.reportDataSet[rowItem.batchId] = {};
            }
            this.setSystemFeilds(rowItem);
          } else {
          }
        });
      }
    },

    // 设置系统id
    setSystemFeilds(data) {
      let _data = {};
      // 是否存在系统
      if (data?.systemResponses) {
        // 有可能不是数组
        _data = Array.isArray(data?.systemResponses)
          ? data?.systemResponses
          : [data?.systemResponses];
        _data.forEach((item, index) => {
          let _copyItem = item;
          // 指定批次
          let designSys = this.reportDataSet[data.batchId];
          // 判断指定系统是否存在
          let existSys = designSys.hasOwnProperty(item.systemId);
          // 不存在
          if (!existSys) {
            designSys[item.systemId] = deepCopy(this.formTemplates); //初始值
          }

          /**为了不影响元数据的鱼池，所有需要在格式化之前把 item copy一份*/

          // 设置损耗
          this.setReportData(data.batchId, item.systemId, item);
          // 设置水质
          this.setWaterRequestData(data.batchId, item.systemId, item);
          // 设置饵料投喂表单
          this.setFeedingRequestData(data.batchId, item.systemId, item);
          // 设置用药表单
          this.setMedicationRequestData(data.batchId, item.systemId, item);
          this.setAquaMedicationRequestData(data.batchId, item.systemId, item);
          // 设置环境
          this.setEnvironmentRecordRequestData(
            data.batchId,
            item.systemId,
            item
          );
          // 设置生长
          this.setGrowthSituationRequestData(data.batchId, item.systemId, item);
          // 设置健康
          this.setHealthRecordRequestData(data.batchId, item.systemId, item);
          // 设置第三方
          this.setInspectionReportRequestData(
            data.batchId,
            item.systemId,
            item
          );
          // 设置镜检
          this.setMicroscopicRecordRequestData(
            data.batchId,
            item.systemId,
            item
          );
        });
      }
    },

    // --------损耗---------------
    setReportData(batchId, systemId, data) {
      // 修改时会传递数据
      const lossData = data?.lossData || {};
      const _lossRequest =
        this.reportDataSet[batchId]?.[systemId]?.lossRequest || {};

      // 循环 fishpondResponses，并根据 lossData 更新 lossWeight, lossCount, lossSpec
      const _data = data.fishpondResponses.map(item => {
        let lossWeight = '';
        let lossCount = '';
        let lossSpec = '';

        if (lossData.data && Array.isArray(lossData.data)) {
          const _lossData = lossData.data.find(
            lossItem => lossItem.fishpondId === item.fishpondId
          );

          if (_lossData) {
            lossWeight =
              _lossData.lossWeight !== undefined ? _lossData.lossWeight : '';
            lossCount =
              _lossData.lossCount !== undefined ? _lossData.lossCount : '';
            lossSpec =
              _lossData.lossSpec !== undefined ? _lossData.lossSpec : '';
          }
        }

        return {
          ...item,
          lossWeight,
          lossCount,
          lossSpec,
        };
      });

      // 回显设置损耗id
      if (lossData.lossId) {
        _lossRequest.lossId = lossData.lossId;
      }

      // 回显设置图片
      if (
        Array.isArray(lossData.uploadFiles) &&
        lossData.uploadFiles.length > 0
      ) {
        _lossRequest.uploadFiles = [...lossData.uploadFiles];
      }

      // 设置备注
      if (lossData.remark) {
        _lossRequest.remark = lossData.remark;
      }

      // 设置损耗原因
      if (lossData.lossReason) {
        _lossRequest.lossReason = lossData.lossReason;
      }

      if (lossData.submitDate) {
        _lossRequest.submitDate = formatDateTime(
          lossData.submitDate ? new Date(lossData.submitDate) : new Date(),
          'YYYY-MM-DD HH:mm'
        );
      }

      // 设置详情
      _lossRequest.details = deepCopy(_data);
    },

    // 投喂 feedFfrom
    setFeedingRequestData(batchId, systemId, data) {
      // 指定批次 指定系统投喂
      let _feedingRequest =
        this.reportDataSet[batchId][systemId]['feedingRequest'];
      let feedFfrom = [];
      let filterData = [];
      // 如果为修改会有此值
      let feedingData = data?.feedingData || [];
      // 在左侧分类添加全部项
      let addAll = { fishpondId: 'all', fishpondCode: '全部' };

      // push表单数据
      if (feedingData?.data?.length) {
        //修改数据 表单
        filterData.push(...feedingData.data);
      }
      if (data?.feedingForm?.length) {
        //新增数据 表单
        filterData.push(...data?.feedingForm);
      }
      if (filterData?.length) {
        // 格式化字段为后端需要的字段
        feedFfrom =
          filterData.reduce((acc, item, index) => {
            const newItem = {
              ...item,
              systemId: data.systemId,
              title: item.baitName || item.title,
              specs: item.baitSpce || item.specs,
              baitName: item.baitName || item.title,
              weight: item.weight,
              type: 'input',
              queue: 'item',
              unit: item?.unit || '',
            };
            acc.push(newItem);
            return acc;
          }, []) || [];
        // 因为在修改时，配置表单数据和 响应表单数据可能存在相同的饵料，需要通过 title进行去重
        feedFfrom = deduplicateArray(feedFfrom, 'title');
      }

      //给每一个鱼池添加表单,如果当前没有返回表单数据，那么赋值为空数组
      const defaultFeedFfrom = Array.isArray(feedFfrom) ? feedFfrom : [];
      // copy鱼池数据，防止数据冲突
      const fishpondResponsesCopy = deepCopy(data.fishpondResponses);
      // 给每个鱼池添加表单
      fishpondResponsesCopy.forEach(
        item => (item['feedFfrom'] = deepCopy(defaultFeedFfrom))
      );

      // 如果当前有鱼池，那么在最前面添加一个全部选项
      if (fishpondResponsesCopy.length) {
        let insterAll = {
          ...addAll,
          // 如果为全部选项添加 是否合并 属性
          feedFfrom: deepCopy(
            defaultFeedFfrom.map(item => ({ ...item, queue: 'all' }))
          ),
        };

        // 在添加全部的时候判断是否为修改，如果为修改需要把旧值赋给feedFfrom全部选项 / 重量
        if (feedingData?.data?.length) {
          insterAll.feedFfrom.forEach(row => {
            feedingData?.data.find(col => {
              if (row?.baitName == col?.title)
                row.weight = parseFloat(col.weight);
            });
          });
        }
        fishpondResponsesCopy.unshift(insterAll);
      }
      // 给每一个鱼池添加detais属性 / 吃料情况 / 备注
      _feedingRequest['details'] = fishpondResponsesCopy;
      _feedingRequest.feedingCondition = ''; //吃料情况
      _feedingRequest.remark = ''; // 备注
      // 如果是修改，添加 feedId
      if (feedingData?.feedingId) {
        _feedingRequest.feedingId = feedingData.feedingId;
        _feedingRequest.uploadFiles = feedingData.uploadFiles;
        _feedingRequest.remark = feedingData.remark;
        _feedingRequest.feedingCondition = feedingData.feedingCondition;
        _feedingRequest.submitDate = formatDateTime(
          feedingData.submitDate
            ? new Date(feedingData.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        );
      }
    },
    // 用药
    setMedicationRequestData(batchId, systemId, data) {
      if (data?.medicationData) {
        this.reportDataSet[batchId][systemId].medicationRequest =
          data.medicationData;
      }
    },

    // 用药2
    setAquaMedicationRequestData(batchId, systemId, data) {
      if (data?.medicationData) {
        this.reportDataSet[batchId][systemId].aquaMedication =
          data.medicationData;
      }
    },

    // 设置环境
    setEnvironmentRecordRequestData(batchId, systemId, data) {
      let env = data?.envData;

      if (env) {
        this.fetchDataByBatchAndSystem().environmentRecordRequest =
          deepCopy(env);

        data.environmentRecordRequest = env;
      }
    },
    // 水质
    setWaterRequestData(batchId, systemId, data, index) {
      let _waterRequest =
        this.reportDataSet[batchId]?.[systemId]['waterRequest'];
      let waters = data?.waterData || data?.waterForm || [];

      // 如果是修改则赋默认值
      _waterRequest.remark = waters?.remark || '';
      _waterRequest.waterId = waters?.waterId || '';
      _waterRequest.location = waters?.location || '';
      _waterRequest.waterResult = waters?.waterResult || '';
      _waterRequest.uploadFiles = waters?.uploadFiles || [];
      _waterRequest.details = [];
      _waterRequest.type = waters?.type || '1'; // 水质类型
      _waterRequest.submitDate = formatDateTime(
        waters?.submitDate ? new Date(waters?.submitDate) : new Date(),
        'YYYY-MM-DD HH:mm'
      );

      // 匹配 filedShow ==1的值
      waters.forEach(item => {
        if (item.filedShow === '1') {
          _waterRequest.details.push({
            ...item,
            [item.fieldCode]: item.value,
          });
        }
      });

      // this.reportDataSet[batchId][systemId]['waterRequest'] = _waterRequest
    },
    // 生长
    setGrowthSituationRequestData(batchId, systemId, data) {
      let _growthData = data?.growthData || {};
      if (_growthData?.id) {
        this.reportDataSet[batchId][systemId].growthSituationRequest =
          _growthData;
      }
    },
    // 健康
    setHealthRecordRequestData(batchId, systemId, data) {
      let _healthData = data?.healthData || {};
      if (_healthData?.id) {
        this.reportDataSet[batchId][systemId].healthRecordRequest = _healthData;
      }
    },
    // 三方
    setInspectionReportRequestData(batchId, systemId, data) {
      let _inspecData = data?.inspecData || {};
      if (_inspecData?.id) {
        this.reportDataSet[batchId][systemId].inspectionReportRequest =
          _inspecData;
      }
    },

    // 暂养----修改中应用
    // setTemporaryCareRecordRequestData(batchId, systemId, data) {
    //   if (data?.temporaryCareData) {
    //     this.reportDataSet[batchId][systemId].temporaryCareRecordRequest =
    //       data.temporaryCareData;
    //   }
    // },

    // 镜检
    setMicroscopicRecordRequestData(batchId, systemId, data) {
      let _microscopicData = data?.microscopicData || {};
      if (_microscopicData?.id) {
        this.reportDataSet[batchId][systemId].microscopicRequest =
          data.microscopicData;
      }
    },

    // 点击保存数据，格式化
    saveDataFormat(batchId, systemId) {
      let params = {};
      // 可能是数组
      let _systemId = this.selectedContext.systemId;
      let _batchId = this.selectedContext.batchId;

      let queryData = this.reportDataSet[_batchId][_systemId];

      // 深拷贝一份，因为需要格式化数据
      let deepColyData = deepCopy(queryData);

      // 由于水质检测是数组，深拷贝不能拷贝数组身上的属性，需要手动 copy一份
      deepColyData['waterRequest']['uploadFiles'] = deepCopy(
        queryData['waterRequest'].uploadFiles
      );

      // 在提交前，统一为所有表单确保并格式化 submitDate 字段
      const allTemplateKeys = Object.keys(this.formTemplates || {});
      allTemplateKeys.forEach(formKey => {
        const formData = deepColyData?.[formKey];
        if (formData && typeof formData === 'object') {
          formData.submitDate = formatDateTime(
            formData.submitDate ? new Date(formData.submitDate) : new Date(),
            'YYYY-MM-DD HH:mm'
          );
        }
      });

      /**
       * 处理数据格式
       * */

      // 水质

      params.waterRequest = {};
      deepColyData.waterRequest.details.forEach(item => {
        params.waterRequest[item['fieldCode']] = item[item.fieldCode];
      });

      deepColyData.waterRequest.waterResult = getFirstItem(
        deepColyData.waterRequest.waterResult
      );

      ['remark', 'location', 'waterResult', 'type', 'submitDate'].forEach(
        key => {
          params.waterRequest[key] = deepColyData.waterRequest[key];
        }
      );
      // 统一格式化水质提交时间
      params.waterRequest.submitDate = formatDateTime(
        deepColyData.waterRequest.submitDate
          ? new Date(deepColyData.waterRequest.submitDate)
          : new Date(),
        'YYYY-MM-DD HH:mm'
      );
      if (!deepColyData.waterRequest?.waterId) {
        params.waterRequest.uploadFiles = deepColyData.waterRequest.uploadFiles
          .map(item => item.filePath)
          .filter(item => item);
      } else {
        params.waterRequest.waterId = deepColyData.waterRequest.waterId;
      }

      // 损耗
      // 过滤没有填入值的损耗鱼池 && item.lossSpec
      let lossDetails = deepColyData.lossRequest.details.filter(
        item => item.lossCount
      );

      let _lossRequest = {
        ...deepColyData.lossRequest,
        details: lossDetails,
        submitDate: formatDateTime(
          deepColyData.feedingRequest.submitDate
            ? new Date(deepColyData.feedingRequest.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
      };

      if (!_lossRequest?.lossId) {
        _lossRequest.uploadFiles = deepColyData.lossRequest?.uploadFiles
          ?.map(item => item.filePath)
          .filter(item => item);
      } else {
        _lossRequest.uploadFiles = [];
      }

      params.lossRequest = _lossRequest;

      // 投喂
      let _feedingStatic = queryData.feedingRequest['details']?._static;
      let result = [];
      let sumWeight = 0;
      deepColyData.feedingRequest.details.forEach(item => {
        const { fishpondId, fishpondCode, unit } = item;

        // 对 feedFfrom 数组进行分组
        item.feedFfrom.forEach(subItem => {
          if (
            subItem.queue != 'all' &&
            subItem.specs &&
            subItem.title &&
            subItem.weight
          ) {
            result.push({
              ...subItem,
              fishpondId,
              fishpondCode,
              unit: isArray(subItem?.unit) ? subItem?.unit[0] : subItem?.unit,
            });
            sumWeight += parseFloat(subItem.weight);
          }
        });
      });

      let _feedingRequest = {
        ...deepColyData.feedingRequest,
        totalWeight: sumWeight,
        details: result,
        remark: deepColyData.feedingRequest.remark,
        submitDate: formatDateTime(
          deepColyData.feedingRequest.submitDate
            ? new Date(deepColyData.feedingRequest.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
        feedingCondition: isArray(deepColyData.feedingRequest.feedingCondition)
          ? deepColyData.feedingRequest.feedingCondition[0]
          : deepColyData.feedingRequest.feedingCondition,
      };

      if (!_feedingRequest?.feedingId) {
        _feedingRequest.uploadFiles = deepColyData.feedingRequest?.uploadFiles
          ?.map(item => item.filePath)
          .filter(item => item);
      } else {
        _feedingRequest.uploadFiles = [];
      }

      params.feedingRequest = _feedingRequest;

      // 环境
      let _environmentRecordRequest = {
        ...deepColyData.environmentRecordRequest,
        environmentDate: formatDateTime(
          deepColyData.environmentRecordRequest.environmentDate
            ? new Date(deepColyData.environmentRecordRequest.environmentDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        )
      };
      if (!deepColyData.environmentRecordRequest.id) {
        _environmentRecordRequest.uploadFiles =
          deepColyData.environmentRecordRequest?.uploadFiles
            ?.map(item => item?.filePath)
            .filter(item => item);
      } else {
        _environmentRecordRequest.uploadFiles = [];
      }

      params.environmentRecordRequest = _environmentRecordRequest;

      // 用药
      const { medicationRequest: medicationRequests } = deepColyData;

      let _unit = isArray(medicationRequests.unit)
        ? medicationRequests.unit[0]
        : medicationRequests.unit;
      const _medicationRecordRequest = {
        unit: _unit,
        purpose: medicationRequests.purpose,
        medicine: medicationRequests.medicine,
        medicationId: medicationRequests.medicationId,
        dosage: medicationRequests.dosage,
        remark: medicationRequests.remark,
        method: medicationRequests.method,
        submitDate: formatDateTime(
          medicationRequests.submitDate
            ? new Date(medicationRequests.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
      };

      if (!_medicationRecordRequest.medicationId) {
        _medicationRecordRequest.uploadFiles = medicationRequests?.uploadFiles
          ?.map(item => item?.filePath)
          .filter(item => item);
      } else {
        _medicationRecordRequest.uploadFiles = [];
      }

      params.medicationRequest = _medicationRecordRequest;

      // 用药
      let aquaMedicationDetails =
        deepColyData.aquaMedication.medicationDetails?.filter(
          item =>
            item.medicine.trim() &&
            item.method &&
            item.dosage &&
            item.unit &&
            item.purpose
        );

      let _aquaMedication = {
        ...deepColyData.aquaMedication,
        medicationDetails: aquaMedicationDetails,
      };
      // 统一格式化动保用药提交时间
      _aquaMedication.submitDate = formatDateTime(
        deepColyData.aquaMedication.submitDate
          ? new Date(deepColyData.aquaMedication.submitDate)
          : new Date(),
        'YYYY-MM-DD HH:mm'
      );

      if (!_aquaMedication?.id) {
        _aquaMedication.uploadFiles = deepColyData.aquaMedication?.uploadFiles
          ?.map(item => item.filePath)
          .filter(item => item);
      } else {
        _aquaMedication.uploadFiles = [];
      }

      params.aquaMedication = _aquaMedication;

      /************************检验三个表单 *******************/
      const {
        growthSituationRequest: _growthSituationRequest,
        inspectionReportRequest: _inspectionReportRequest,
        healthRecordRequest: _healthRecordRequest,
      } = deepColyData;

      // 生长
      params.growthSituationRequest = {
        ..._growthSituationRequest,
        submitDate: formatDateTime(
          deepColyData.growthSituationRequest.submitDate
            ? new Date(deepColyData.growthSituationRequest.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
      };
      if (!_growthSituationRequest.id) {
        params.growthSituationRequest.uploadFiles =
          deepColyData.growthSituationRequest?.uploadFiles
            ?.map(item => item.filePath)
            .filter(item => item);
      } else {
        params.growthSituationRequest.uploadFiles = [];
      }

      // 健康
      params.healthRecordRequest = {
        ..._healthRecordRequest,
        submitDate: formatDateTime(
          deepColyData.healthRecordRequest.submitDate
            ? new Date(deepColyData.healthRecordRequest.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
        uploadFiles: deepColyData.healthRecordRequest?.uploadFiles?.map(
          item => item.filePath
        ),
      };

      if (!_healthRecordRequest.id) {
        params.healthRecordRequest.uploadFiles =
          deepColyData.healthRecordRequest?.uploadFiles
            ?.map(item => item.filePath)
            .filter(item => item);
      } else {
        params.healthRecordRequest.uploadFiles = [];
      }

      // 检验
      params.inspectionReportRequest = {
        ..._inspectionReportRequest,
        submitDate: formatDateTime(
          deepColyData.inspectionReportRequest.submitDate
            ? new Date(deepColyData.inspectionReportRequest.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        ),
        uploadFiles: deepColyData.inspectionReportRequest?.uploadFiles?.map(
          item => item.filePath
        ),
      };
      if (!_inspectionReportRequest.id) {
        params.inspectionReportRequest.uploadFiles =
          deepColyData.inspectionReportRequest?.uploadFiles
            ?.map(item => item.filePath)
            .filter(item => item);
      } else {
        params.inspectionReportRequest.uploadFiles = [];
      }

      /************************新增1.20表单 镜检*******************/
      // 镜检
      const { microscopicRequest: microscopicRequests } = deepColyData;
      const _microscopicRequest = {
        ...microscopicRequests,
        submitDate: formatDateTime(
          microscopicRequests.submitDate
            ? new Date(microscopicRequests.submitDate)
            : new Date(),
          'YYYY-MM-DD HH:mm'
        )
      };

      if (!_microscopicRequest.id) {
        _microscopicRequest.uploadFiles = microscopicRequests?.uploadFiles
          ?.map(item => item?.filePath)
          .filter(item => item);
      } else {
        _microscopicRequest.uploadFiles = [];
      }

      params.microscopicRequest = _microscopicRequest;

      // 暂养
      // const { temporaryCareRecordRequest: temporaryCareRecordRequests } =
      //   deepColyData;
      // const _temporaryCareRecordRequest = {
      //   ...temporaryCareRecordRequests,
      // };

      // if (!_temporaryCareRecordRequest.id) {
      //   _temporaryCareRecordRequest.uploadFiles =
      //     temporaryCareRecordRequests?.uploadFiles
      //       ?.map(item => item?.filePath)
      //       .filter(item => item);
      // } else {
      //   _temporaryCareRecordRequest.uploadFiles = [];
      // }

      // params.temporaryCareRecordRequest = _temporaryCareRecordRequest;
      // console.log('params.temporaryCareRecordRequest', params.temporaryCareRecordRequest);

      // 添加公共值
      params.batchId = this.selectedContext.batchId;
      params.systemId = this.selectedContext.systemId;
      params.batchCode = this.selectedContext.batchCode;
      params.systemCode = this.selectedContext.systemCode;
      params.datailId = this.selectedContext?.datailId;
      return params;
    },
    // 获取指定表单的鱼塘
    getSpecifiedFormFishPool(batchId, systemId, type) {
      returnthis.reportDataSet[batchId][systemId][type];
    },

    // 设置监测系统 批次等
    setCurrentSelectTarget(data) {
      this.selectedContext = data;
    },
    // 读取缓存数据替换指定批次 系统的表单数据
    loadAndReplaceCachedFormData(batchId, systemId, data) {
      this.reportDataSet[batchId][systemId] = data;
    },
  },
  getters: {
    // 根据指定批次=>指定系统获取数据
    fetchDataByBatchAndSystem: state => {
      let _batchId = state.selectedContext.batchId;
      let _systemId = state.selectedContext.systemId;

      return () => {
        if (_systemId && _batchId) {
          let getterss = state?.reportDataSet[_batchId][_systemId];

          return getterss;
        } else {
          return { details: [] };
        }
      };
    },

    // 获取当前存储批次 系统 id
    getSelectedContext(state) {
      return state.selectedContext;
    },
  },
  // persist: true,
});
